import { FormattedMessage } from 'react-intl';
import Icon from "../Icon";

const Links = ({linkList, linkTypes, mode}) => {

    return (<>
    <h3 className={`${mode==="dark"?"theme-color":"blue"} links-title`}><Icon icon="link-45deg" className={mode==="dark"?"theme-color":"blue"} /> <FormattedMessage id="links" defaultMessage="Hivatkozások" /></h3>
    {linkTypes && linkTypes.map(linkType => {
        const currentLinks = linkList ? linkList.filter(link => link.linktype === linkType.type): null;
        if (currentLinks.length>0) {
            return (<div className="chart-links">
                <h4><Icon icon={linkType.icon}  className={mode==="dark"&& "gray"}  /> {linkType.title}</h4>
                {/* eslint-disable */currentLinks.map(link => <div className="chart-link"><a  href={link.link} target="_blank" >{link.title}</a></div>)}
            </div>)
        }
        return <></>
    })}
    </>)
}

export default Links;
